import React from 'react';
import PreviewAddAttachment from '../../../PreviewAddAttachment';

interface IAttachmentRendererProps {
  documentId: string;
  billId: string;
  billStatus: string;
}

export const AttachmentRenderer = ({ documentId, billId, billStatus }: IAttachmentRendererProps) => (
  <div className='flex justify-center' data-testid='BillsHub__table-column-attachment'>
    <PreviewAddAttachment documentId={documentId} billId={billId} billStatus={billStatus} />
  </div>
);
